import {ProductCategoryService} from "../resource";

const ProductCategoryModule = {
	namespaced: true,
	state: {
		datas: [],
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		}
	},
	actions: {
		createData({ commit, state }, data) {
			return ProductCategoryService.ProductCategoryCreate(data);
		},

		updateData({ commit, state }, data) {
			return ProductCategoryService.ProductCategoryUpdate(data.id,data.payload);
		},

		deleteData({ commit, state }, data) {
			return ProductCategoryService.ProductCategoryDelete(data);
		},

		async listData({ commit, state }, data) {
			try
			{
				const response = await ProductCategoryService.ProductCategoryList(data);
				commit("SET_DATA", response.data.Data);
			}
			catch (error)
			{
				commit("SET_DATA", []);
			}
		}
	},
	getters: {
		getData(state) {
			return state.datas;
		}
	},
};

export default ProductCategoryModule;